/**
 * Shared auth/API fetch defaults for SEC-1.10 cookie sessions.
 * Same-site `/auth` + `/graphql` rely on the httpOnly `dn_session` cookie;
 * Bearer from localStorage remains as a dual-mode fallback (local cross-origin).
 */

export const AUTH_API_URL =
  process.env.REACT_APP_AUTH_ENDPOINT || "http://localhost:8080";

export function bearerHeaders(
  token?: string | null
): Record<string, string> {
  const t = token ?? (typeof window !== "undefined" ? localStorage.getItem("token") : null);
  return t ? { Authorization: `Bearer ${t}` } : {};
}

/** fetch with credentials so the browser sends/stores dn_session. */
export function authFetch(
  input: RequestInfo | URL,
  init: RequestInit = {}
): Promise<Response> {
  const headers = new Headers(init.headers || {});
  return fetch(input, {
    ...init,
    credentials: "include",
    headers,
  });
}
